import { Breadcrumbs } from "@/components"
import { CoordSetAndLook } from "@/components/CoordSetAndLook"
import Layout from "@/layout"
import { buildPageProps } from "@/lib/ssg/slug"
import { breadcrumbArray } from "@jog/react-components"
import { type RedisShopTheLookItem, buildShopTheLookPage as buildShopTheLookPageBase, prismicClient } from "@jog/shared"
import type { ShopTheLookDetailPage, StaticPropsCommon } from "@jog/types"
import type { GetStaticPropsContext, GetStaticPropsResult } from "next"

import { type NotFoundProps, getNotFoundProps } from "../notFound"
import { type CoordSetAndLookDocument } from "../prismicio/types.generated"

export const buildShopTheLookPage = async (
    redisItem: RedisShopTheLookItem,
    pageContext: GetStaticPropsContext<{ slug: string[] }>
): Promise<
    GetStaticPropsResult<(StaticPropsCommon & { page: ShopTheLookDetailPage<CoordSetAndLookDocument> }) | NotFoundProps>
> => {
    try {
        const client = prismicClient({ previewData: pageContext.previewData })
        const pageProps = await buildShopTheLookPageBase<CoordSetAndLookDocument>(client, redisItem)
        return buildPageProps(pageContext, pageProps)
    } catch (e) {
        console.error(e)
        return getNotFoundProps(pageContext)
    }
}

export const ShopTheLookDetailPageContent = ({ page }: { page: ShopTheLookDetailPage<CoordSetAndLookDocument> }) => {
    const breadcrumb = breadcrumbArray(page.path.split("/"))
    return (
        <Layout>
            <Breadcrumbs list={breadcrumb} />
            <CoordSetAndLook prismic={page.prismic.data} products={page.products} last={breadcrumb.at(-2)} />
        </Layout>
    )
}
